import React from 'react'
import { Link } from 'react-router-dom';

function ServiceTeaser({title, image, description, link}) {
  return (
     <section className="individual-teaser-container">
        <h2>{title}</h2>
        <div className= "individual-teaser-content">
          <div className="teaser-img-container">
            <img src={ image} alt="Dumpster Truck" />
          </div>
          <div className="individual-teaser-info">
            <p>{description}</p>
            <Link to= {link}>Learn More...</Link>
          </div>
        </div>
      </section> 
  )
}

export default ServiceTeaser;